import { POST } from "../../index";

export const selectByCarRealTimeStatus = (param) => POST("/v1/realTimeStatus/selectByCarRealTimeStatus", param);
export const getCarRealTimeStatus = (param) => POST("/v1/realTimeStatus/getCarRealTimeStatus", param);
export const getDriverSwipingCardSituation = (param) => POST("/v1/realTimeStatus/getDriverSwipingCardSituation", param);
export const selectOneCar = (param) => POST("/v1/realTimeStatus/selectOneCar", param);
export const selectOneDriver = (param) => POST("/v1/realTimeStatus/selectOneDriver", param);
export const selectOneTerminal = (param) => POST("/v1/realTimeStatus/selectOneTerminal", param);
export const selectCarLocation = (param) => POST("/v1/realTimeStatus/selectCarLocation", param);
export const getCarOperationList = (param) => POST("/v1/realTimeStatus/getCarOperationList", param);

